import { buttonsWrapperClass, wrapperClass } from "./social-login.styles";
import type { SocialLoginProps } from "./social-login.types";
import { SocialLoginButton } from "../../social-login-button";

export const SocialLogin = ({ onSuccess }: SocialLoginProps) => {
	return (
		<div className={wrapperClass}>
			<div className={buttonsWrapperClass}>
				<SocialLoginButton provider="google" onClick={onSuccess} />
				<SocialLoginButton provider="apple" onClick={onSuccess} />
			</div>
		</div>
	);
};
